"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFormInitialValues = void 0;
exports.CheckoutFormInitialValues = {
    firstName: '',
    lastName: '',
    fullNameOrCompanyName: '',
    addressLine1: '',
    addressLine2: '',
    houseUnit: '',
    city: '',
    postalCode: '',
    state: '',
    country: 'Malaysia',
    phoneNumber: '',
    emailAddress: '',
    shipToDifferentAddress: false,
    notes: '',
    paymentMethod: 'fpx',
    paymentBankCode: '',
    shippingAddressLine1: '',
    shippingAddressLine2: '',
    shippingHouseUnit: '',
    shippingCity: '',
    shippingPostalCode: '',
    shippingState: '',
    shippingCountry: 'Malaysia',
};
//# sourceMappingURL=FLDStore.js.map